import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutRevenueGoalByTractorReport } from "./autogen/AutogenLayoutRevenueGoalByTractorReport";

export class RevenueGoalByTractorReport extends AutogenLayoutRevenueGoalByTractorReport {
    override onLoad(): void | Promise<void> {
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
    }

    excludabletextboxFleetTextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_tractor = "Y";
    }
    excludabletextboxTrailerTextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y";
    }
}
